// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__Ugrmd","content":"Consent_content__1woLV","footer":"Consent_footer__3nElW"};